import { useEffect, useState } from 'react';

/** Quanto o checkout espera o `/applications/params` antes de mostrar o formulário mesmo assim. */
export const FINANCE_WAIT_MS = 4000;

/**
 * O formulário pode aparecer? Espera o `/applications/params` (que diz se a plataforma pode receber
 * agora — pay #619) para o comprador não começar a preencher e ver a página virar "pagamentos
 * indisponíveis" no meio. A espera é curta e falha aberta: passados `timeoutMs` sem resposta, o
 * formulário aparece — o params fora do ar não pode derrubar a venda (e a cobrança ainda responde
 * 409 se for o caso).
 *
 * O front não sabe se a trava do pay está em `enforce` antes de o params responder, então a espera
 * vale sempre que `enabled`; na prática o params chega junto com o produto, o checkout e o tema, que
 * a página já espera.
 */
export function useFinanceReady(
	finance: unknown,
	enabled: boolean,
	timeoutMs = FINANCE_WAIT_MS
): boolean {
	const hasFinance = !!finance;
	const [timedOut, setTimedOut] = useState(false);

	useEffect(() => {
		if (!enabled || hasFinance) return;
		const timer = window.setTimeout(() => setTimedOut(true), timeoutMs);
		return () => window.clearTimeout(timer);
	}, [enabled, hasFinance, timeoutMs]);

	return !enabled || hasFinance || timedOut;
}

/**
 * Quem espera o params: produto/plano pago fora do preview. Grátis não trava e o preview é o admin
 * desenhando a página. Preço ainda não carregado conta como pago — a página já está no skeleton.
 * A mesma regra na Single (preço do produto) e no Recurring (preço do plano).
 */
export const waitsForFinance = (
	price: number | undefined,
	isPreview: boolean
): boolean => !isPreview && price !== 0;
